import React from 'react';
import Stack from '@mui/material/Stack';
import FiberSmartRecordIcon from '@mui/icons-material/FiberSmartRecord';

export default function CmmSubTitle(props) {
  const { title, sx } = props;

  return (
    <Stack sx={{ mx: 1, mb: 1, fontSize: '13px', fontWeight: 'bold', ...sx }} spacing={1} direction="row">
      <FiberSmartRecordIcon color="primary" size="large" sx={{ fontSize: '16px' }} />
      <span>{title}</span>
    </Stack>
  );
}
